import {FC, useEffect, useState} from 'react'
import {site} from '../../constants/global'
import {getRegData} from "../../wordpress/operations/get-reg-data";
import {resetBooking} from "../../lib/booking";

interface Props {
    booking?: Booking,
    setBooking: Function
}

const RegSearch: FC<Props> = ({ booking, setBooking}) => {
    const [reg, setReg] = useState<any>(booking.car.reg);
    const [autoNext, setAutoNext] = useState(false);

    const _getRegData = (reg:string, autoload:boolean) => {
        setReg(reg)
        if(reg.length > 5) {
            const session = parseInt(sessionStorage.getItem('mech_session') || Date.now().toString())
            getRegData(reg, session).then((val) => {
                booking = resetBooking();
                booking.car.reg = val.reg
                booking.car.brand = val.brand
                booking.car.model = val.model
                booking.car.year = val.year
                booking.car.color = val.color
                booking.car.authorized = val.authorized
                booking.car.valid = val.valid
                booking.car.manual = val.manual
                booking.car.arval = val.arval
                booking.car.autoload = autoload
                booking.loading = false

                setBooking({
                    ...booking,
                })

                /*if(!booking.car.authorized)
                    booking.modal = 2;*/

                if (!val.valid) {
                    booking.car.autoload = false;
                    booking.modal = 3;
                }

                if (val.manual) {
                    booking.car.autoload = false;
                    booking.modal = 4;
                }

                setBooking({
                    ...booking,
                })

                if (booking.car.autoload) {
                    setAutoNext(true);
                }
            })
        }
    }

    useEffect(() => {
        if (autoNext) {
            document.getElementById('btn-next')?.click();
            setAutoNext(false);
        }
    }, [autoNext])

    if(window.react_data.reg) {
        _getRegData(window.react_data.reg.toUpperCase().replace(/\s/g,''), true)
        window.react_data.reg = ''
    }

    const updateReg = (e: any) => {
        const userInput = e.target.value.toUpperCase().replace(/\s/g,'')
        _getRegData(userInput, false)
    }

    if(booking.loading)
        return

    return (
        <div className="reg-search">
            <label className="required">Registreringsnummer</label>
            <div className="reg-search__content">
                <input id="booking-registration" value={reg} type="text" name="reg" placeholder="BEY045" onChange={updateReg}/>
                <img alt="sweden" src={site + "/wp-content/themes/mechanum/dist/img/input-icon.png"}/>
            </div>
        </div>
    )
};

export default RegSearch
